import React from "react";
import DateInput from "../../components/Date/DateInput";
const DateField = ({
  isError,
  useFormProps,
  field,
  text
}) => {
  return /*#__PURE__*/React.createElement(DateInput, {
    id: field?.id,
    isError: isError,
    fieldSettings: field?.settings || {},
    fieldControl: useFormProps.control,
    registerProps: {
      ...useFormProps?.register(field?.id, {})
    },
    text: text
  });
};
export default DateField;
//# sourceMappingURL=DateField.js.map